module.exports = __webpack_public_path__ + "img/footer.2de8828c.jpg";